/**
 * Defines all supported kinds of inspections than can be done at an aggregate.
 *
 * !!!
 * IMPORTANT: This enum is also defined in the following repositories: backoffice-backend => keep the versions synchronized
 * !!!
 */

export enum ValidationSeverity {
  MANDATORY = 'MANDATORY',
  RECOMMENDED = "RECOMMENDED",
  VOLUNTARY = 'VOLUNTARY',
  INFORMATIONAL = 'INFORMATIONAL',
}
